module.exports = __webpack_public_path__ + "static/media/MensajeGray.ad842aa1.svg";